/* eslint-disable camelcase */
import React, { Component } from "react";

import {
  CButton,
  CCol,
  CRow,
  CInput,
  CSpinner,
  CCard,
  CCardImg,
  CCardBody,
  CLink
} from "@coreui/react";
import { BsSearch } from "react-icons/bs";
import { RiUserSearchFill, RiGroupFill, RiTeamLine } from "react-icons/ri";
import { SiPowerbi } from "react-icons/si";
import { TbNotes } from "react-icons/tb";
import { VscGraph } from "react-icons/vsc";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import "./styles.css";
import { debounce } from "../../../utils/debounce";

class DashboardProfessorAlagoas extends Component {
  constructor(props) {
    super(props);
    const tutorialModalStored = localStorage.getItem(
      `${
        this.props.user.user?.id ? this.props.user.user?.id : ""
      }tutorialModalGestorClosed`
    );

    const tutorialModal = tutorialModalStored
      ? JSON.parse(tutorialModalStored)
      : false;

    const userActiveRole = this.props.general.active_roles.role_id;
    // const getVideoTutorial = userRole => {
    //   switch (userRole) {
    //     case 3:
    //     case 4:
    //     case 5:
    //       return {
    //         title: "Alocação de Trilhas - Gestor!",
    //         url: "https://www.youtube.com/embed/aJ9m-U8eRJU?si=7eneWKauIN30RdjM"
    //       };
    //     default:
    //       return {
    //         title: "Alocação de Trilhas - Gestor!",
    //         url: "https://www.youtube.com/embed/aJ9m-U8eRJU?si=7eneWKauIN30RdjM"
    //       };
    //   }
    // };

    // this.videoTutorial = getVideoTutorial(userActiveRole);
    // const videoTutorialRoles = [3, 4, 5];

    this.state = {
      // statisticsInfo: null,
      busca: "",
      usersSearch: [],
      loadingUsersSearch: false,
      showUserSearch: false
      // modal: videoTutorialRoles.includes(userActiveRole)
      //   ? !tutorialModal
      //   : false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  async getStatisticsInfo() {
    let statisticsInfo = {
      evaluations_count: 0,
      students_count: 0,
      completed_evaluations: 0,
      average_grade: 0
    };

    await axios
      .get(`${URL.api}statistics/studentsCount`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` },
        params: {
          user_id: this.props.user.user.id
        }
      })
      .then(resp => {
        if (resp.data?.success) {
          statisticsInfo.students_count = resp.data.data.students_count;
        }
      });

    await axios
      .get(`${URL.api}statistics/evaluationsCount`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` },
        params: {
          user_id: this.props.user.user.id
        }
      })
      .then(resp => {
        if (resp.data?.success) {
          statisticsInfo.evaluations_count = resp.data.data.evaluations_count;
        }
      });

    await axios
      .get(`${URL.api}statistics/completedEvaluationsCount`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` },
        params: {
          user_id: this.props.user.user.id
        }
      })
      .then(resp => {
        if (resp.data?.success) {
          statisticsInfo.completed_evaluations =
            resp.data.data.completed_evaluations;
          statisticsInfo.average_grade = resp.data.data.average_grade;
        }
      });

    // eslint-disable-next-line react/no-unused-state
    this.setState({ statisticsInfo });
  }

  componentDidMount() {
    (async () => {
      await this.getStatisticsInfo();
    })();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.busca !== this.state.busca) {
      const delayedSearch = debounce(
        () => this.searchStudents(this.state.busca),
        300
      );
      delayedSearch();
    }
  }

  searchStudents(text) {
    if (text) {
      axios
        .get(
          `${URL.api}access/user/searchUsers?search=${text}&group_id=${this.props.user.user_roles[0].group_id}&region_id=${this.props.user.user_roles[0].region_id}&role_id=7&school_id=${this.props.general.active_roles.school_id}`, // colocar school_id
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          this.setState({
            loadingUsersSearch: true,
            showUserSearch: true
          });

          if (resp.data?.success) {
            const usersSearch = resp.data.data;

            this.setState({
              usersSearch,
              loadingUsersSearch: false,
              showUserSearch: true
            });
          }
        });
    } else {
      this.setState({
        loadingUsersSearch: false,
        showUserSearch: false
      });
    }
  }

  getShortcuts() {
    const userRole = this.props.general.active_roles.role_id;
    const userRegion = this.props.general.active_roles.region_id;

    const biByRegionList = [
      [
        {
          id: 230,
          url: "https://app.powerbi.com/view?r=eyJrIjoiMmFjOTQ4Y2YtMDhjZi00Yzc0LWIyOTgtNjhhNDhkMDc1ZWJkIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 231,
          url: "https://app.powerbi.com/view?r=eyJrIjoiZGM0YjZmNTUtYzBjOS00MDExLTlmZjktMzQxOWE2Yjk4ODIyIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 232,
          url: "https://app.powerbi.com/view?r=eyJrIjoiMjUyOGE1ZWQtY2IwNS00NWY3LWE1YTQtMDkwYTkzZTY3NjdmIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 233,
          url: "https://app.powerbi.com/view?r=eyJrIjoiZDM3MzEzZGMtNzg4OS00ODBjLTlkNDEtOWQ3NTI1M2FkMWQ3IiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 234,
          url: "https://app.powerbi.com/view?r=eyJrIjoiODZkODkzYzItZDZiNi00N2ExLWE4OGYtOTQ5MTBmNjI2YTU5IiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 235,
          url: "https://app.powerbi.com/view?r=eyJrIjoiZmI0OTczMTYtZmUwZC00ZTY2LTgyMzQtNzIxYTFjZGUxZjkwIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 236,
          url: "https://app.powerbi.com/view?r=eyJrIjoiYjJkMGIwM2MtOGRiZC00YjhhLWJiOGQtYzViMTU2NzU5ZTRmIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 237,
          url: "https://app.powerbi.com/view?r=eyJrIjoiYjQ2ODljOWUtOGIzYi00ODczLWEwMTAtYmM4NmM1MGQ0MzNjIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 238,
          url: "https://app.powerbi.com/view?r=eyJrIjoiYWJmZDVmOWYtZmE5My00ZGI2LWIxMWYtZDMyZDU1NTJjNmIxIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 239,
          url: "https://app.powerbi.com/view?r=eyJrIjoiZTI2ZmI3ZjMtMmZjMi00OTQ2LWJjNDUtODkyNTFkNWUzNDIxIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 240,
          url: "https://app.powerbi.com/view?r=eyJrIjoiYTExZjQ3YzQtYTA0Mi00MmQ2LTkxNmQtYTBmOTYwMzlkNmEzIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 241,
          url: "https://app.powerbi.com/view?r=eyJrIjoiYzcyNjQwMWItZjk5Zi00ODkzLWIyOTgtZTcyYmUzMTM2YzNiIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        },
        {
          id: 242,
          url: "https://app.powerbi.com/view?r=eyJrIjoiMmRjMDM3YzEtN2ViNS00Yjc3LTlhOGUtZmYzYjQ4NDI0NDE5IiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9&pageName=ReportSectiond1b8dfeb329e4b56509d"
        }
      ]
    ];

    let shortCutList = [];

    if (userRole <= 6) {
      shortCutList.push(
        {
          url: "classroom/me",
          color: "#D52B36",
          icon: RiGroupFill,
          text: "Minhas turmas"
        },
        {
          url: "Userlist",
          color: "#83B838",
          icon: RiTeamLine,
          text: "Listagem de usuários"
        }
      );
    }
    if (userRole <= 5) {
      shortCutList.push(
        // {
        //   url: "/evaluation/bank",
        //   color: "#1CA6DE",
        //   icon: MdOutlineTask,
        //   text: "Banco de Avaliações"
        // },
        {
          url: "/evaluation/bank/gradepanel",
          color: "#efc261",
          icon: TbNotes,
          text: "Painel de Notas"
        },
        {
          url: "/partialprogression/grade/show",
          color: "#efc261",
          icon: TbNotes,
          text: "Painel de Notas Trilhas PP"
        }
      );
      if (userRole === 2) {
        shortCutList.push({
          url: "https://app.powerbi.com/view?r=eyJrIjoiMTBlMzNhN2UtZTk1NC00MzEyLWFlMjktYzAxM2YyZGQyZTFhIiwidCI6IjhkOTM3ZWFjLWFkOTktNGZlZi1iMmIyLTMxOTk4OWMxMzE3OCJ9",
          color: "#5F1961",
          icon: SiPowerbi,
          text: "BI",
          newWindow: true
        });
      }
      if (userRole === 3) {
        const biUrl = biByRegionList
          .flat()
          .find(item => item.id === userRegion)?.url;
        shortCutList.push({
          url: biUrl,
          color: "#5F1961",
          icon: SiPowerbi,
          text: "BI",
          newWindow: true
        });
      }
      if (userRole === 4) {
        shortCutList.push({
          url: "/partialprogression/grade/send",
          color: "#efc261",
          icon: TbNotes,
          text: "Lançamento de Notas Trilhas PP"
        });
      }

      shortCutList.push({
        url: "/bank/evaluation/statistics",
        color: "#D52B36",
        icon: VscGraph,
        text: "Estatísticas"
      });
    }

    return shortCutList;
  }

  closeModal = () => {
    localStorage.setItem(
      `${
        this.props.user?.user?.id ? this.props.user.user?.id : ""
      }tutorialModalGestorClosed`,
      true
    );
    // eslint-disable-next-line react/no-unused-state
    this.setState({ modal: false });
  };

  render() {
    const { busca, showUserSearch, loadingUsersSearch, usersSearch } =
      this.state;

    return (
      <div className="w-100">
        {/* <Modal
          isOpen={this.state.modal}
          toggle={this.closeModal}
          className="educandus"
        >
          <ModalHeader toggle={this.closeModal}>
            {this.videoTutorial.title}
          </ModalHeader>
          <ModalBody>
            <iframe
              width="100%"
              height="315"
              src={this.videoTutorial.url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </ModalBody>
        </Modal> */}
        <CRow className=" mb-3">
          <CCol xs="12" lg="7" className="d-flex flex-column">
            <div className="mb-5">
              <h4 className="font-weight-bold alag">Pesquisar estudante:</h4>
              <div className="d-flex">
                <CInput
                  type="search"
                  value={busca}
                  onChange={e => this.setState({ busca: e.target.value })}
                  className="searchInputAlag"
                  placeholder="Digite o nome do estudante"
                  autoComplete="off"
                />
                <CButton className="searchButtonAlag">
                  <BsSearch />
                </CButton>
              </div>

              <div>
                {showUserSearch && (
                  <div className="student-search-container">
                    {loadingUsersSearch ? (
                      <>
                        <CSpinner color="black" size="sm" />
                      </>
                    ) : (
                      <CRow>
                        {usersSearch.map(student => (
                          <CCol xs="12" className="d-flex">
                            <CCard
                              className="student-search-item-container mb-0"
                              onClick={() =>
                                this.props.history.push(
                                  `/profile/summarystudent/${student.id}`
                                )
                              }
                            >
                              <CRow>
                                <CCardImg
                                  className="student-search-item-img"
                                  src={
                                    student.photo
                                      ? URL.img + student.photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                />
                                <CCardBody>
                                  <span
                                    className="d-inline-block text-truncate"
                                    style={{ maxWidth: "450px" }}
                                  >
                                    {student.name}
                                  </span>
                                </CCardBody>
                              </CRow>
                            </CCard>
                          </CCol>
                        ))}
                      </CRow>
                    )}
                  </div>
                )}
              </div>
            </div>
            {!showUserSearch && (
              <RiUserSearchFill
                className="student-search-icon mt-5"
                color="#c1c1c1"
              />
            )}
          </CCol>
          <CCol xs="12" lg="5" className="pl-3">
            <div className="w-100">
              <div className="d-flex align-items-center mb-3">
                <h4 className="font-weight-bold mb-0 alagoas-title">Atalhos</h4>
              </div>
              <CRow>
                {this.getShortcuts().map((shortcut, index) => (
                  <CCol xs="6" xxl="4" className="mb-4 d-flex">
                    <CButton
                      color="white"
                      onClick={() => {
                        shortcut?.newWindow
                          ? window.open(shortcut.url)
                          : this.props.history.push(shortcut.url);
                      }}
                      className="p-0 h-100 w-100 border-default rounded-lg d-flex flex-column justify-content-center align-items-center"
                      block
                      style={{ fontSize: "1.125rem", width: "12rem" }}
                    >
                      <div
                        className="p-4 flex-1 text-center w-100"
                        style={{
                          minWidth: "100%",
                          backgroundColor: shortcut.color,
                          borderRadius: "inherit",
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      >
                        <shortcut.icon size={48} color="white" />
                      </div>
                      <div className="p-3 text-title h-100 d-flex align-items-center">
                        {shortcut.text}
                      </div>
                    </CButton>
                  </CCol>
                ))}
              </CRow>
              {/* <div className="d-flex align-items-start flex-column mt-5 mb-3">
                <h2 className="font-weight-bold mb-0 alagoas-title">
                  Estatísticas
                </h2>
                <CLink to="/bank/evaluation/statistics">
                  <p>Ver mais</p>
                </CLink>
              </div> */}
              {/* <CRow style={{ marginBottom: "30px" }}>
                <CCol>
                  <WidgetIcon
                    title="Avaliações"
                    data={this.state.statisticsInfo?.evaluations_count}
                  />
                </CCol>

                <CCol>
                  <WidgetIcon
                    title="Alunos"
                    data={this.state.statisticsInfo?.students_count}
                    bgColor="#f7f7f7"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <WidgetIcon
                    title="Avaliações Finalizadas"
                    data={this.state.statisticsInfo?.completed_evaluations}
                    bgColor="#f7f7f7"
                  />
                </CCol>

                <CCol>
                  <WidgetIcon
                    title="Nota Média"
                    data={
                      this.state.statisticsInfo?.averange_grade
                        ? Number(
                            this.state.statisticsInfo?.average_grade
                          ).toFixed(2)
                        : "Em processamento"
                    }
                  />
                </CCol>
              </CRow> */}
              {/* START: STATISTICS TRAIL */}
              {/* <CRow>
                <CCol>
                  <WidgetIcon
                    title="Avaliações"
                    data={this.state.statisticsInfo?.evaluations_count}
                  />
                </CCol>

                <CCol>
                  <WidgetIcon
                    title="Alunos"
                    data={this.state.statisticsInfo?.students_count}
                    bgColor="#f7f7f7"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <WidgetIcon
                    title="Avaliações Finalizadas"
                    data={this.state.statisticsInfo?.completed_evaluations}
                    bgColor="#f7f7f7"
                  />
                </CCol>
                <CCol>
                  <WidgetIcon
                    title="Nota Média"
                    data={
                      this.state.statisticsInfo?.averange_grade
                        ? Number(
                            this.state.statisticsInfo?.average_grade
                          ).toFixed(2)
                        : "Em processamento"
                    }
                  />
                </CCol>
              </CRow> */}
            </div>
          </CCol>
        </CRow>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardProfessorAlagoas);
